import { render, staticRenderFns } from "./HSpacer.vue?vue&type=template&id=5bcffdf3&scoped=true&"
import script from "./HSpacer.vue?vue&type=script&lang=js&"
export * from "./HSpacer.vue?vue&type=script&lang=js&"
import style0 from "./HSpacer.vue?vue&type=style&index=0&id=5bcffdf3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcffdf3",
  null
  
)

export default component.exports